import utils from 'helpers/utils';
import {
    FETCH_USER_PRODUCT_MEMBERSHIP,
    FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIP_SUCCESS,
    FETCH_USER_PRODUCT_MEMBERSHIPS,
    FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIPS_SUCCESS,
} from 'store/actions/types';

export const fetchUserProductMemberships = (payload) => {
    let params = {
        ...payload.params,
        size: payload.size ? payload.size : 24,
        sort_by: payload.field ? payload.field : 'name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (payload.product_id) {
        params.product_id = [
            payload.product_id,
        ];
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = {
            ...params,
            ...filters,
        };
    }

    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIPS,
        payload: {
            ...payload,
            params,
        },
    };
};

export const fetchUserProductMembershipsFailure = (error) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE,
        error,
    };
};

export const fetchUserProductMembershipsSuccess = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIPS_SUCCESS,
        payload,
    };
};

export const fetchUserProductMembership = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP,
        payload,
    };
};

export const fetchUserProductMembershipFailure = (error) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE,
        error,
    };
};

export const fetchUserProductMembershipSuccess = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_SUCCESS,
        payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/product-memberships/fetchUserProductMemberships.js